import { render, staticRenderFns } from "./ExpenseListAddNew.vue?vue&type=template&id=2352f6cd&"
import script from "./ExpenseListAddNew.vue?vue&type=script&lang=js&"
export * from "./ExpenseListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports